import React, { FC } from "react"

import "./Level.scss"
import { LevelProps } from "./Level.types"

const Level: FC<LevelProps> = ({
    mobile,
    className,
    children,
    ...props
}: LevelProps) => {
    let klass = `zb-level ${className ?? ""}`
    if (mobile) klass += " zb-is-mobile"

    return (
        <div className={klass} {...props}>
            {children}
        </div>
    )
}

export default Level
